import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getNameDay'
})
export class GetNameDayPipe implements PipeTransform {

  transform(value: number): string {
    let day = '';
    switch (value) {
      case 0:
        day = 'DOM';
        break;
      case 1:
        day = 'LUN';
        break;
      case 2:
        day = 'MAR';
        break;
      case 3:
        day = 'MIE';
        break;
      case 4:
        day = 'JUE';
        break;
      case 5:
        day = 'VIE';
        break;
      case 6:
        day = 'SÁB';
        break;
    }
    return day;
  }

}
